export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_04.dc225e5f.jpg";